import { html, type SYSAction } from "../../../../_ovlclient/src"
import { Data } from "../../../src/dataapi"
import {
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType,
  HookFormInit_Type,
  HookFormChanged_Type,
  HookTableBeforeSave_Type,
  HookTableBeforeSave_ReturnType,
  //HookTableServerBeforeMergeRow,
  HookTableServerBeforeMergeRow_Type,
  //HookTableServerBeforeMergeRow_ReturnType,
} from "../../../src/global/hooks"
import { FieldSetVal, FieldVal } from "../../../src/library/forms/fieldapi"
import {
  ProcessEnd,
  ProcessStart,
} from "../../../src/library/longrunningprocesstracker/processapi"
import { TableCellVal, TableGet } from "../../../src/library/table/tableapi"

const HookField_CapturedRequest_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  let responseBody
  if (value.row["Request"].ToBeDeletedManually.ResponseBody) {
    responseBody = JSON.stringify(
      JSON.parse(value.row["Request"].ToBeDeletedManually.ResponseBody),
      null,
      2
    )
  }
  console.log(responseBody)
  return {
    res: responseBody,
  }
}

const HookFormInit: SYSAction<HookFormInit_Type> = async (value) => {
  let formState = value.formState
  await FieldSetVal(
    formState.fields["ResponseBody"],
    JSON.stringify(
      JSON.parse(
        value.formState.row["Request"].ToBeDeletedManually.ResponseBody
      ),
      null,
      2
    )
  )
  await FieldSetVal(formState.fields["Url"], value.formState.row["Request"].Url)
}

const HookField_Url_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  let url = value.row["Request"].Url
  return {
    res: url,
  }
}

const HookTableBeforeSave: SYSAction<
  HookTableBeforeSave_Type,
  HookTableBeforeSave_ReturnType
> = (value) => {
  return { resolve: "Cancel" }
}

const HookFormChanged: SYSAction<HookFormChanged_Type> = async (value) => {
  if (
    value.changedField.fieldKey === "JmesPathExpression" ||
    value.changedField.fieldKey === "ResponseBody"
  ) {
    let expression = await FieldVal(
      value.formState.fields["JmesPathExpression"]
    )
    if (expression) {
      var responseBody = await FieldVal(value.formState.fields["ResponseBody"])
      if (responseBody) {
        await FieldSetVal(value.formState.fields["JmesPathResult"], null)
        let tb = TableGet(value.formState.tableDefId)
        let endpoint = tb.def.server.endpoint
        ProcessStart("SYSEPTCheck")
        try {
          let result = await Data(`${endpoint}/check`, {
            Id: value.row["Id"],
            Expression: expression,
            ResponseBody: responseBody,
          })
          await FieldSetVal(
            value.formState.fields["JmesPathResult"],
            result.data.Result
          )
        } catch (error) {
          value.validationsAdd("SYSEPTInvalidExpression", {
            fields: value.formState.fields["JmesPathExpression"],
            validation: { translationReps: [error.message] },
            setFocus: true,
          })
        } finally {
          ProcessEnd("SYSEPTCheck")
        }
      }
    }
  }
}

export let hooks = {
  HookField_CapturedRequest_GetValueRender,
  HookField_Url_GetValueRender,
  HookFormInit,
  HookFormChanged,
  HookTableBeforeSave,
}
